import { jsPDF } from "jspdf";
import { detailTrainingTel1ForExport, getConfig } from "../../../config/apiSPA";

async function Tel1ToPdf(id) {
  async function exportPdf(data) {
    const doc = new jsPDF({
      unit: "mm",
      format: "a4",
    });
    const maxPage = data.length;

    for (let i = 0; i < maxPage; i++) {
      const pdf = await generate(doc, data[i]);
      if (i + 1 < maxPage) {
        await pdf.x.addPage();
      } else {
        pdf.x.save("Training Evaluasi Level 1");
      }
    }

    return false;
  }
  const fetch = new Promise((resolve, reject) => {
    detailTrainingTel1ForExport(id).then((res) => {
      resolve(res.data);
    });
  });

  return await exportPdf(await fetch);
}

export default Tel1ToPdf;

async function generate(x, data) {
  function loadImage(url) {
    return new Promise(async (resolve, reject) => {
      const config = await getConfig();
      const image = new Image();
      image.src = `${config.baseUrl}/api${url}`;
      image.onload = () => resolve(image);
      image.onerror = reject;
    });
  }

  const img = await loadImage("/generalImage/tel1Form");
  x.addImage(img, "jpg", 0, 3, 220, 290);

  x.setFontSize(10);
  x.setFont("Helvetica");
  x.text(data.header.trainingTitle, 132, 40);
  x.text(data.header.trainingLocationAndDate, 132, 47);
  x.text(data.header.institution, 132, 53);

  //   Program---------------------------------------------
  function checkProg(value) {
    if (value === 1) return 132;
    if (value === 2) return 145;
    if (value === 3) return 158;
    if (value === 4) return 172;
    if (value === 5) return 184;
    if (value === 6) return 196;
  }
  data.program.forEach((prog) => {
    if (prog.id === 1) x.text("V", checkProg(prog.value), 88.5);
    if (prog.id === 2) x.text("V", checkProg(prog.value), 95.5);
    if (prog.id === 3) x.text("V", checkProg(prog.value), 102);
  });

  //   Tool------------------------------------------

  function checkTool(value) {
    if (value === 1) return 132;
    if (value === 2) return 145;
    if (value === 3) return 158;
    if (value === 4) return 172;
    if (value === 5) return 184;
    if (value === 6) return 196;
  }
  data.tool.forEach((tool) => {
    if (tool.id === 1) x.text("V", checkTool(tool.value), 122);
    if (tool.id === 2) x.text("V", checkTool(tool.value), 128.5);
    if (tool.id === 3) x.text("V", checkTool(tool.value), 136);
  });

  //   Fasilitator 1--------------------------------------------

  const fas0 = data.fasilitators[0];
  x.setFontSize(6);
  x.text(fas0.fasilitatorName, 138, 147.5);
  x.setFontSize(18);

  function checkFas0(value) {
    if (value === 1) return 127;
    if (value === 2) return 133.5;
    if (value === 3) return 140.5;
    if (value === 4) return 147;
    if (value === 5) return 153.5;
    if (value === 6) return 160;
  }
  fas0.result.forEach((fasilitator0) => {
    if (fasilitator0.id === 1) x.text("O", checkFas0(fasilitator0.value), 160.5);
    if (fasilitator0.id === 2) x.text("O", checkFas0(fasilitator0.value), 174.5);
    if (fasilitator0.id === 3) x.text("O", checkFas0(fasilitator0.value), 185);
  });

  //   Fasilitator 2--------------------------------------------
  if (data.fasilitators.length > 1) {
    const fas1 = data.fasilitators[1];
    x.setFontSize(6);
    x.text(fas1.fasilitatorName, 176, 147.5);
    x.setFontSize(18);

    function checkFas1(value) {
      if (value === 1) return 166.5;
      if (value === 2) return 173;
      if (value === 3) return 180;
      if (value === 4) return 186;
      if (value === 5) return 192;
      if (value === 6) return 197.5;
    }
    fas1.result.forEach((fasilitator1) => {
      if (fasilitator1.id === 1) x.text("O", checkFas1(fasilitator1.value), 160.5);
      if (fasilitator1.id === 2) x.text("O", checkFas1(fasilitator1.value), 174.5);
      if (fasilitator1.id === 3) x.text("O", checkFas1(fasilitator1.value), 185);
    });
  }

  //   overAll---------------------------------------------------
  x.setFontSize(18);
  if (data.overall === 1) x.text("O", 130.5, 198.5);
  if (data.overall === 2) x.text("O", 143.5, 198.5);
  if (data.overall === 3) x.text("O", 156.5, 198.5);
  if (data.overall === 4) x.text("O", 170, 198.5);
  if (data.overall === 5) x.text("O", 182.5, 198.5);
  if (data.overall === 6) x.text("O", 195, 198.5);

  //   overAllComment-------------------------------------------------------
  x.setFontSize(5);

  data.overallComments.forEach((val) => {
    if (val.id === 1) x.text(val.value === null ? "-" : val.value, 126, 210.5, { maxWidth: 82 });
    if (val.id === 2) x.text(val.value === null ? "-" : val.value, 126, 218.8, { maxWidth: 82 });
    if (val.id === 3) x.text(val.value === null ? "-" : val.value, 126, 229, { maxWidth: 82 });
  });

  //   otherComment-------------------------------------------------------
  x.setFontSize(5);
  data.otherComments.forEach((val) => {
    if (val.id === 1) x.text(val.value === null ? "-" : val.value, 126, 248.8, { maxWidth: 82 });
    if (val.id === 2) x.text(val.value === null ? "-" : val.value, 126, 256.8, { maxWidth: 82 });
    if (val.id === 3) x.text(val.value === null ? "-" : val.value, 126, 270.3, { maxWidth: 82 });
  });

  const img2 = await loadImage("/generalImage/sisLogo");
  x.addImage(img2, "jpg", 18, 10, 28, 10);
  const now = new Date();
  const dateTime = now.toLocaleString();
  x.text("this document was generated from ppdmaco.com at :" + dateTime, 8.5, 287);

  return { x: x };
}
